module.exports = __webpack_public_path__ + "static/media/gryphon_musee_everyartoriginal_4.dfdfaf89.jpg";